import { observer } from 'mobx-react-lite'
import { EmptyState } from 'shared/ui'
import { ChatbotTestButton, ChatbotTestNewButton } from 'pages/chatbot/ui/ChatbotButtons'
import { useChatbotContext } from 'pages/chatbot/context'

export const DialogEmpty = observer(
  ({ buttonComponent }: { buttonComponent?: React.ReactNode }) => {
    const { id } = useChatbotContext()
    const button = buttonComponent || (id ? <ChatbotTestButton /> : <ChatbotTestNewButton />)
    return (
      <EmptyState
        boxProps={{ sx: { textAlign: 'center' } }}
        iconProps={{ icon: 'messageStarCircle', color: 'var(--content-brand-primary)' }}
        title='See your agent in action'
        text='Simulate conversations with no credit usage'
        typographyProps={{
          variant: 'body-md-regular',
          ariaLabel: 'DialogEmptyText',
        }}
        actions={button}
      />
    )
  }
)
